import * as PIXI from "pixi.js";
import Bg from "./entities/bg";
import PolygonCon from "./entities/polygonCon";
import Polygon from "./entities/polygon";
import SideNumberCon from "./entities/SideNumberCon";
import RadiusCon from "./entities/RadiusCon";

const WIDTH = 960;
const HEIGHT = 540;

export default class Game extends PIXI.Application {
  static instance: Game;

  bottomContainer = new PIXI.Container();
  middleContainer = new PIXI.Container();
  topContainer = new PIXI.Container();

  constructor(view: HTMLCanvasElement) {
    super();
    if (!Game.instance) {
      Game.instance = this;
    }

    this.init({
      view: view,
      antialias: true,
      backgroundColor: 0xFFFFFF,
      width: WIDTH,
      height: HEIGHT
    }).then(() => {
      this.stage.addChild(this.bottomContainer, this.middleContainer, this.topContainer)
      new Bg(WIDTH, HEIGHT);
      new PolygonCon();
      new Polygon();
      new SideNumberCon();
      new RadiusCon();

      this.ticker.add(delta => this.update(delta))

    })
  }
  static getInstance(): Game {
    return Game.instance;
  }
  getDim() {
    return { WIDTH, HEIGHT };
  }
  update(delta: PIXI.Ticker) {
  }
}

const canvas = document.querySelector("#canvas") as HTMLCanvasElement;

if (canvas) {
  (window as any).context = new Game(canvas)
} else {
  console.error("Canvas is not found")
}